import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from "@eb/i18n";

import { Password } from '@eb/eds-password';
import { ValidationFormField } from '@eb/eds-validation-form-field';

import { shouldDisplayError } from '@eb/redux-form-tools';
import { PasswordStrengthMeter } from '@eb/eds-password';

/*
 When the form isLogin, we want the password field to be autofocused and to hide
 password length validation errors while the user types.
*/

export default class PasswordField extends React.PureComponent {
    static propTypes = {
        isLogin: PropTypes.bool,
        requiredPassword: PropTypes.bool,
        onRememberMeChange: PropTypes.func,
        isStatic: PropTypes.bool,

        /* Needed due to an issue with redux form rendering validation errors on
        nested stateful components. Even though submitFailed is not used,
        submitFailed needs to be passed to the nested stateful component
        to ensure validation errors are rendered.
        Ticket: EB-60045 */
        submitFailed: PropTypes.bool,

        /* Needed to force autofocus on the PW reset form */
        autoFocus: PropTypes.bool,

        onChange: PropTypes.func,
        onIconClick: PropTypes.func,
    };

    state = {
        inputPassword: '',
    };

    _handleChange = (inputPassword) => {
        this.setState({
            inputPassword,
        });
        if (this.props.onChange) {
            this.props.onChange();
        }
    };

    //When user clicks on View Password
    _handleIconClick = () => {
        const { onIconClick } = this.props;
        if (onIconClick) {
            onIconClick();
        }
    };
    render() {
        const { isLogin, requiredPassword, isStatic } = this.props;
        const { inputPassword } = this.state;
        const style = isStatic ? 'static' : 'dynamic';

        const { autoFocus } = this.props;
        let passwordStrengthMeter;

        if (!isLogin) {
            passwordStrengthMeter = (
                <PasswordStrengthMeter inputPassword={inputPassword} />
            );
        }

        return (
            <div>
                <ValidationFormField
                    name="password"
                    label={gettext('Password')}
                    shouldDisplayError={shouldDisplayError}
                    v2={true}
                >
                    <Password
                        name="password"
                        id="password"
                        required={requiredPassword}
                        autoFocus={autoFocus}
                        label={gettext('Password')}
                        data-automation="signup-password-field"
                        onChange={this._handleChange}
                        onIconClick={this._handleIconClick}
                        style={style}
                        bottomSpacing={0}
                    />
                </ValidationFormField>
                {passwordStrengthMeter}
            </div>
        );
    }
}
